module.exports = __webpack_public_path__ + "static/media/white_mountain_black.5c92d7a0.png";